import * as React from 'react';
import { observer } from 'mobx-react';
import { IInstructorMessageControlProps } from './IInstructorMessageControlProps';
import { InstructorImage } from './InstructorImage/InstructorImage';
import { InstructorMessage } from './InstructorMessage/InstructorMessage';
import { ImageHandler } from 'Components/ImageHandler';

@observer
export class InstructorMessageControl extends React.Component<IInstructorMessageControlProps> {
  constructor(props: IInstructorMessageControlProps) {
    super(props, undefined);
  }

  render() {
    const tpsContainerClassName = 'instructor-message-container-tps row hidden-print';
    const printContainerClassName = 'instructor-message-container visible-print-block';
    const webContainerClassName = 'instructor-message-container hidden-print';
    const hasMessage = this.props.instructorMessage !== '';

    if (!this.props.isTps && !hasMessage) return null;
    else {
      return (
        <div className="instructor-message-control">
          <div className={this.props.isTps ? tpsContainerClassName : webContainerClassName}>
            {this.props.isWeb && this.props.instructorId && (
              <div className="instructor-image-wrapper">
                <img
                  className="instructor-image"
                  src={ImageHandler.getImageUrl(this.props.instructorId)}
                  alt=""
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = 'Images/no-avatar.png';
                  }}
                />
              </div>
            )}
            {!this.props.isWeb && this.props.instructorImage && (
              <InstructorImage InstructorImage={this.props.instructorImage} />
            )}

            <InstructorMessage
              instructorMessage={this.props.instructorMessage}
              instructorImage={this.props.instructorImage}
              instructorName={this.props.instructorName}
              isTps={this.props.isTps}
              isPrint={false}
              onInstructorMessageChanged={this.props.onInstructorMessageChanged}
            />
          </div>
          {hasMessage && (
            <div className={printContainerClassName}>
              {this.props.isWeb && this.props.instructorId && (
                <div className="instructor-image-wrapper">
                  <img
                    className="instructor-image"
                    src={ImageHandler.getImageUrl(this.props.instructorId)}
                    alt=""
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = 'Images/no-avatar.png';
                    }}
                  />
                </div>
              )}
              {!this.props.isWeb && this.props.instructorImage && (
                <InstructorImage InstructorImage={this.props.instructorImage} />
              )}
              <InstructorMessage
                instructorMessage={this.props.instructorMessage}
                instructorImage={this.props.instructorImage}
                instructorName={this.props.instructorName}
                isTps={this.props.isTps}
                isPrint={true}
                onInstructorMessageChanged={this.props.onInstructorMessageChanged}
              />
            </div>
          )}
        </div>
      );
    }
  }
}
